import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { PavilionLogo } from './PavilionLogo';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Workshops',
    href: '#workshops'
  }, {
    name: 'Vendors',
    href: '#vendors'
  }, {
    name: 'Partners',
    href: '#partners'
  }];
  return <nav className="sticky top-0 z-50 bg-foodCream border-b-4 border-foodMaroon" data-id="element-137" data-mp="1fzp30vapa83d">
      <div className="bg-foodTeal text-foodCream text-center text-sm font-bold uppercase tracking-wide py-2 px-4" data-id="element-138" data-mp="1fxut0c0yw0e2">
        Open Saturdays & Sundays • 12 PM – 6 PM
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139" data-mp="1pq0jfhbkm9r5">
        <div className="flex justify-between items-center h-20" data-id="element-140" data-mp="1uouzibi5lk7k">
          <a href="#" aria-label="The Food Pavilion, home" className="shrink-0" data-id="element-141" data-mp="1uqekugio2lg7">
            <PavilionLogo data-id="element-142" data-mp="1yo3u1il0pm46" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8 ml-8 lg:ml-12" data-id="element-143" data-mp="23q1m92bebr99">
            {links.map(link => <a key={link.name} href={link.href} className="font-bold hover:text-foodOrange transition-colors duration-150" data-id="element-144" data-mp="1y79rvoaxwwnu">
                {link.name}
              </a>)}
            <a href="https://www.en2action.org/" target="_blank" rel="noopener noreferrer" className="font-bold hover:text-foodOrange transition-colors duration-150" data-id="element-145" data-mp="1k6p56h1wmgp2">
              En2Action
            </a>
            <a href="#popups" className="bg-foodOrange text-white px-6 py-2.5 font-bold border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#2A1B14] hover:shadow-[2px_2px_0px_0px_#2A1B14] hover:translate-y-[2px] hover:translate-x-[2px] transition-[transform,box-shadow] duration-150 ease-out" data-id="element-146" data-mp="2844n9ybx2gxw">
              Pop Ups
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-3" data-id="element-147" data-mp="tvn6b3djfex1">
            <a href="https://ibwaterfrontpark.com/" target="_blank" rel="noopener noreferrer" aria-label="India Basin Waterfront Park" data-id="element-148" data-mp="tyj1ijy03phs">
              <img src="https://cdn.magicpatterns.com/uploads/nYkbhZjohnn3Xbm3r4WWAs/Untitled_design_(5).png" alt="India Basin Waterfront Park" className="h-12 w-auto object-contain" data-id="element-149" data-mp="k4iycnma4ubp" />
            </a>
            <button onClick={() => setIsOpen(!isOpen)} className="hover:text-foodOrange focus:outline-none" aria-label="Toggle menu" aria-expanded={isOpen} data-id="element-150" data-mp="f8ty0i2fr9ec">
              {isOpen ? <X size={32} data-id="element-151" data-mp="68f8f6ifv851" /> : <Menu size={32} data-id="element-152" data-mp="1vls98lrcee1e" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden bg-foodCream border-t-4 border-foodMaroon absolute w-full" data-id="element-153" data-mp="20jalom4kjbe5">
          <div className="px-4 pt-2 pb-6 space-y-2 shadow-xl" data-id="element-154" data-mp="2apbs6u18rraj">
            {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-2xl font-display font-bold uppercase hover:bg-foodGold transition-colors" data-id="element-155" data-mp="25qqp8mulutie">
                {link.name}
              </a>)}
            <a href="https://www.en2action.org/" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block px-3 py-3 text-2xl font-display font-bold uppercase hover:bg-foodGold transition-colors" data-id="element-156" data-mp="2th4k0l4kr6go">
              En2Action
            </a>
            <a href="#popups" onClick={() => setIsOpen(false)} className="block mt-4 text-center bg-foodOrange text-white px-6 py-3 font-bold text-xl border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#2A1B14]" data-id="element-157" data-mp="182qerzviikz3">
              Pop Ups
            </a>
          </div>
        </div>}
    </nav>;
}